module.exports = __webpack_public_path__ + "static/media/expandPreview.296a433f.svg";